import {combineReducers} from 'redux';
import pad from 'pad-left';

import {
  REQUEST_SHOPS, RECEIVE_SHOPS, REQUEST_SHOPS_FAILED,
  REQUEST_SHOP, RECEIVE_SHOP,

  SET_POSITION, SET_ADDRESS, INVALIDATE_RESULT,
  APPLY_FILTER, REMOVE_FILTER, SET_OPTION, SET_COUNTRY,
  SHOW_SEARCH_DETAILS, HIDE_SEARCH_DETAILS,

  REQUEST_USER_POSITION, RECEIVE_USER_POSITION,

  HIGHLIGHT_SHOP, UNHIGHLIGHT_SHOP,
  SELECT_SHOP, DESELECT_SHOP,
  SHOW_SHOP_DETAILS, HIDE_SHOP_DETAILS,
  SHOW_MESSAGE, HIDE_MESSAGE,
  SHOW_MAP, SHOW_LIST,
  SET_MAP_CENTER, SET_MAP_ZOOM, SET_MAP_BOUNDS,

  SET_LANGUAGE, SET_CALLBACK
} from '../actions';

function highlightedShop(state = '', action) {
  switch(action.type) {
    case HIGHLIGHT_SHOP:
      return action.parcelShopNumber;

    case RECEIVE_SHOPS:
    case UNHIGHLIGHT_SHOP:
      return '';

    default:
      return state;
  }
}

function selectedShop(state = '', action) {
  switch(action.type) {
    case SELECT_SHOP:
      return action.parcelShopNumber;

    case DESELECT_SHOP:
      return '';

    default:
      return state;
  }
}

function filter(state = { luggage: false, boxes: false, time: false }, {type, filter}) {
  switch (type) {
    case REMOVE_FILTER:
      return Object.assign({}, state, {
        [filter]: false
      });

    case APPLY_FILTER:
      return Object.assign({}, state, {
        luggage: filter.luggage,
        boxes: filter.boxes,
        time: filter.time.enable ? {
          day: filter.time.day,
          time: `${filter.time.hour}:${pad(parseInt(filter.time.minute), 2, '0')}`
        } : false
      });


    default:
      return state;
  }
}

function search(state = {
  isFetching: false,
  isValid: true,
  result: [],
  address: '',
  showSearchDetails: document.documentElement.clientWidth < 768 ? false : true,
  position: {lat: 0, lng: 0},
  filter: {}
}, action){
  switch (action.type) {
    case SHOW_SEARCH_DETAILS:
      window.wts.push(['send', 'click', {linkId: 'Filter.Detailsuche'}]); //nur beim öffnen der Detailsuche
      return Object.assign({}, state, {
        showSearchDetails: true
      });

    case HIDE_SEARCH_DETAILS:
      return Object.assign({}, state, {
        showSearchDetails: false
      });

    case REMOVE_FILTER:
    case APPLY_FILTER:
      return Object.assign({}, state, {
        filter: filter(state.filter, action)
      });

    case SET_ADDRESS:
      return Object.assign({}, state, {
        address: action.address
      });

    case SET_POSITION:
      return Object.assign({}, state, {
        position: action.position
      });

    case REQUEST_SHOPS:
      return Object.assign({}, state, {
        isFetching: true,
        isValid: true
      });

     case REQUEST_SHOPS_FAILED:
       return Object.assign({}, state, {
         isFetching: false,
         isValid: true
       });

    case RECEIVE_SHOPS:
    const paketfuxxIDs = [669001, 669049];
    const paketParcelLockIDs = [666800, 666830];
    let shopID;
    const shopList = action.result.map(shop => {
        shopID = Number(shop.parcelShopNumber);
        shop.isPaketFuxx = (shopID >= paketfuxxIDs[0] && shopID <= paketfuxxIDs[1]);
        shop.isPaketParcelLock = (shopID >= paketParcelLockIDs[0] && shopID <= paketParcelLockIDs[1]);
        return shop;
      });

      return Object.assign({}, state, {
        isFetching: false,
        isValid: true,
        lastUpdated: action.receivedAt,
        result: shopList
      });

     case INVALIDATE_RESULT:
      return Object.assign({}, state, {
        isValid: false
      });
     default:
      return state;
  }
}

function user(state = {
  isLocating: false,
  address: '',
  position: ''
}, action) {
  switch (action.type) {
    case REQUEST_USER_POSITION:
      return Object.assign({}, state, {
        isLocating: true,
        position: '',
        address: ''
      });

     case RECEIVE_USER_POSITION:
       return Object.assign({}, state, {
         isLocating: false,
         position: action.position
       })

    default:
      return state;
  }
}

function config(state = {
  language: 'de',
  country: 'de',
  callbackUrl: undefined,
  sortCode1: undefined
}, action) {
  switch (action.type) {
    case SET_OPTION:
      return Object.assign({}, state, {
        [action.option]: action.value
      });

    case SET_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language
      });

    case SET_COUNTRY:
      return Object.assign({}, state, {
        country: action.country
      });

    case SET_CALLBACK:
      return Object.assign({}, state, {
        callbackUrl: action.callbackUrl
      });
    default:
      return state;
  }
}

function shops(state = {}, action) {
  switch (action.type) {
    case REQUEST_SHOP:
    case RECEIVE_SHOP:
      return Object.assign({}, state, {
        [action.id]: shop(state[action.id], action),
        [action.sortCode1]: shop(state[action.sortCode1], action)
      });
    default:
      return state;
  }
}

function shop(state = false, action) {
    switch (action.type) {
    case REQUEST_SHOP:
        return 'fetching';
    case RECEIVE_SHOP:
        const shopID = Number(action.result.parcelShopNumber);
        const paketfuxxIDs = [669001, 669049];
        const paketParcelLockIDs = [666800, 666830];
        const mediaMarktParcelIDs = [676935, 676984];

        // is this the proper fix for the sortCode1 issue in MarkerContainer.js?
        const isDisabled = !!config.sortCode1 && action.result.sortCode1 !== parseInt(config.sortCode1, 10);

        action.result.isPaketFuxx = (shopID >= paketfuxxIDs[0] && shopID <= paketfuxxIDs[1]);
        action.result.isPaketParcelLock = (shopID >= paketParcelLockIDs[0] && shopID <= paketParcelLockIDs[1]);
        action.result.isMediaMarktParcel = (shopID >= mediaMarktParcelIDs[0] && shopID <= mediaMarktParcelIDs[1]);
        action.result.sortCode1 = action.sortCode1 ? action.sortCode1 : 'notSet';
        action.result.isDisabled = isDisabled;
        return action.result;
    default:
        return state;
    }
  }

function message(state = '', action) {
  switch (action.type) {
    case SHOW_MESSAGE:
      return action.message
    case HIDE_MESSAGE:
      return '';
  }

  return state;
}

function currentTab(state = 'list', action) {
  switch (action.type) {
    case SHOW_LIST:
      return 'list'
    case SHOW_MAP:
      return 'map';
    default:
      return state;
  }
}

function overlay(state = false, action) {
  switch (action.type) {
    case SHOW_SHOP_DETAILS:
      return action.parcelShopNumber;

    case HIDE_SHOP_DETAILS:
      return false;

    default:
      return state;
  }
}

function map (state = {
  center: {lat: 0, lng: 0},
  zoom: 10,
  dirty: false
}, action) {
  switch (action.type) {
    case SET_MAP_BOUNDS:
      return Object.assign({}, state, {
        dirty: action.dirty
      });
    case SET_MAP_CENTER:
      return Object.assign({}, state, {
        center: action.position
      });
    case SET_MAP_ZOOM:
      return Object.assign({}, state, {
        zoom: action.zoom
      });
    default:
      return state;
  }
}

const rootReducer = {
  highlightedShop,
  selectedShop,
  overlay,
  search,
  user,
  config,
  shops,
  message,
  currentTab,
  map
};

export default rootReducer;
